<script setup>
const {
  applicationId,
  label,
  value,
  document,
  isDisabled = false,
  isEditing = false,
  canDelete = false,
} = defineProps({
  applicationId: String,
  label: String,
  value: String,
  document: {
    type: Object,
    default(rawProps) {
      return {};
    },
  },
  isDisabled: Boolean,
  isEditing: Boolean,
  canDelete: Boolean,
});

const emits = defineEmits(["onChange"]);

const toast = useToast();
const confirm = useConfirm();

const isEdit = ref(false);
const updateLabel = ref("");
const updateValue = ref("");

const onEdit = () => {
  if (isDisabled) return;
  isEdit.value = true;
};

const onSave = () => {
  emits("onChange", updateValue);
};

const onUpdate = async () => {
  emits("onChange", updateValue.value);
  await useApiFetch(`/student-applications/${applicationId}/documents`, {
    method: "POST",
    body: {
      label: updateLabel,
      input_value: updateValue,
      input_type: "text",
    },
    onResponse() {
      toast.add({
        severity: "success",
        summary: "Saved!.",
        life: 3000,
      });
      // refreshNuxtData("student-application-detail");
    },
  });
};

const onLabelUpdate = async (value) => {
  updateLabel.value = value;
  // if (updateValue !== "") await onUpdate();
};

const onDelete = async () => {
  await useApiFetch(`student-application-documents/${document.id}/remove`, {
    method: "POST",
    onResponse() {
      toast.add({
        severity: "success",
        summary: "Successfully deleted.",
        life: 3000,
      });
      refreshNuxtData("student-application-detail");
    },
  });
};

const confirmDelete = (event) => {
  confirm.require({
    header: "Confirm",
    message: "Do you want to delete this record?",
    rejectProps: {
      label: "Cancel",
      severity: "secondary",
      outlined: true,
    },
    acceptProps: {
      label: "Delete",
      severity: "danger",
    },
    accept: () => {
      onDelete();
    },
    reject: () => {},
  });
};

onMounted(() => {
  updateLabel.value = label;
  updateValue.value = value;
});
</script>

<template>
  <!-- <div v-if="isEdit" v-focustrap>
    <div class="flex justify-between">
      <InputText
        v-model="updateValue"
        type="text"
        size="small"
        :placeholder="label"
        autofocus
      />
      <div class="flex gap-4 items-center">
        <i
          class="pi pi-check text-green-600 text-sm cursor-pointer"
          @click="onSave"
        ></i>
        <i
          class="pi pi-times text-rose-600 text-sm cursor-pointer"
          @click="onCancel"
        ></i>
      </div>
    </div>
  </div> -->
  <div class="space-y-3">
    <div class="flex justify-between gap-4 items-center">
      <p class="text-sm text-[#282E38] font-medium">{{ label }}</p>
      <!-- <Button
        text
        icon="pi pi-trash"
        security="danger"
        rounded
        @click="confirmDelete($event)"
      ></Button> -->
      <div class="flex justify-between gap-2 items-center">
        <Button
          label="Open Link"
          as="a"
          :href="value"
          target="_blank"
          rel="noopener"
          link
          class="!py-0"
          :pt="{
            label: 'text-sm text-gray-800 font-medium',
          }"
        >
        </Button>
        <i
          v-if="canDelete"
          class="pi pi-trash text-surface-500 dark:text-white text-sm cursor-pointer"
          @click="confirmDelete($event)"
        ></i>
      </div>
    </div>
    <!-- <p v-if="isDisabled" class="text-[#4B5563] text-xs lg:text-sm">
      {{ value }}
    </p> -->
    <InputText
      v-model="updateValue"
      placeholder="Empty"
      class="placeholder:text-xs lg:placeholder:text-sm text-[#4B5563] text-xs lg:text-sm"
      fluid
      @keyup.enter="onUpdate"
      :disabled="isDisabled"
    />
  </div>
</template>
